require('./bootstrap');
require('select2');
/*custom js*/
require('./custom');
require('./input-validate');
require('./revamp/jquery-menu-cart');
require('./checkout');
require('./hut-reward');
require('./location');